export const CHIME_LOGS_REGEXP = /\[INFO\] Chime/;
